import { SOPaymentStatus } from '../enums'

export const soPaymentStatusOptions = [
  { id: SOPaymentStatus.Pending, name: 'รอการชำระเงิน' },
  { id: SOPaymentStatus.Deposit, name: 'ชำระมัดจำแล้ว' },
  { id: SOPaymentStatus.Paid, name: 'ชำระแล้ว' },
]
